module.exports = __webpack_public_path__ + "img/ranking.bb87373e.svg";